<mat-card class="calendar-widget-daily-view calendar-mat-card" *ngIf="!isCalendarCollapsed">
    <mat-card class="calendar-widget-week-view calendar-mat-card">
        <mat-card class="calendar-widget-title calendar-mat-card">
            <mat-card-content>
                <h2 class="calendar-header-text">
                    <span> {{ "MyCalendar" | translate | uppercase}} </span>
                    <span>
                        <i class="bi bi-chevron-left" (click)="prevMonth()" *ngIf="selectedMonth > 1"></i>
                        {{years[selectedMonth - 1] | translate | uppercase }}
                        <i class="bi bi-chevron-right" (click)="nextMonth()" *ngIf="selectedMonth < years.length"></i>
                    </span>
                </h2>
            </mat-card-content>
        </mat-card>
        <mat-card-content>
            <div class="row days-of-week">
                <div class="col-lg-1" (click)="prevWeek()" [ngClass]="days[0] > 1 ? 'controls' : ''">
                    <i class="bi bi-chevron-left" *ngIf="days[0] > 1"></i>
                </div>
                <div class="col-lg-2 controls" *ngFor="let day of days"   
                    [ngClass]="selectedDay == day && selectedDayMonth == selectedMonth ? 'selected-day' : ''"
                    (click)="onDayClick(day)">
                    <h2>{{day}}</h2>
                    <h2>{{getDayOfWeekInEs(day, selectedMonth, true) | translate}}.</h2>
                </div>
                <div class="col-lg-1" (click)="nextWeek()" [ngClass]="days[4] < daysInSelectedMonth ? 'controls' : ''">
                    <i class="bi bi-chevron-right" *ngIf="days[4] < daysInSelectedMonth"></i>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card-content class="calendar-widget-daily-view-details" [ngClass]="{isDisabledDashboard: !isClearDisabled(),isEnabledDashboard:isClearDisabled()}">
        <div class="appointment-container" >
            <h1 class="appointment-date">
                {{years[selectedDayMonth - 1] | translate | titlecase}} {{selectedDay}} - {{getDayOfWeekInEs(selectedDay,
                selectedDayMonth)| translate | titlecase}}
            </h1>
            <div class="loading-containerDashboard">
                <section *ngIf="isLoading" style="margin: auto">
                    <div  class="pulsing">
                      <mat-spinner [diameter]="50" ></mat-spinner>
                    </div>
                    <p class="pulsing">{{"Loading" | translate }}</p>
                  </section>
              
            </div>
            <div class="container-fluid" *ngFor="let appointment of appointmentsData" >
               
                <div class="row">
                    <div class="col-lg-10 vertical-align-middle">
                        <h2>
                            <span><b> {{appointment.time}} - {{appointment.clientFullName}} </b></span>

                            <span *ngIf="helperService.user.role.roleId !== 3"> <br> {{ appointment.serviceName | translate}}</span>

                            <span *ngIf="helperService.user.role.roleId === 2 || 
                                         helperService.user.role.roleId === 3 || 
                                         helperService.user.role.roleId === 6"> <br> {{appointment.plate}} - {{appointment.brandName}}
                            </span>
                            
                            <span *ngIf="helperService.user.role.roleId === 1"> <br> {{appointment.brandName}}</span>
                            
                            <span *ngIf="helperService.user.role.roleId === 2 ||
                                         helperService.user.role.roleId === 6"> <br> {{ "Advisor" | translate }}: {{appointment.advisorFullName}}
                            </span>
                        </h2>
                    </div>
                    <div class="col-lg-1 text-center vertical-align-middle">
                        <div class="appointment-status-icon" [ngClass]="appointment.statusName" matTooltipPosition="above" [matTooltip]="(appointment?.statusName || 'Estado desconocido') | translate"></div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            </div>

        </div>
    </mat-card-content>
</mat-card>
